export const shouldLoad = () => document.querySelector('.klt-card-gallery') !== undefined;